<template>
  <div id='bd-contact-aside'>
    <div class="contact-search">
      <el-button style="float: left;" size="mini" icon="el-icon-plus" circle @click="showCreateGroupDialog()">
      </el-button>
      <el-input style="width: 70%;" size="mini" :placeholder="searchTip" suffix-icon="el-icon-search" v-model="search"
        clearable></el-input>
      <el-button style="float: right;" size="mini" icon="el-icon-refresh" circle @click="refreshData()"></el-button>
    </div>
    <div style="height: calc(100% - 60px); overflow-y: auto;">
      <el-collapse v-model="activeNames" @change="handleChange">
        <!-- <el-collapse-item name="1">
          <template slot="title">
            <div style="margin-left: 20px;">
              新朋友
            </div>
          </template>
        </el-collapse-item> -->
        <!-- <el-collapse-item name="2">
          <template slot="title">
            <div style="margin-left: 20px;">
              频道
            </div>
          </template>
        </el-collapse-item> -->
        <el-collapse-item name="3">
          <template slot="title">
            <div style="margin-left: 20px;">
              {{ collapseGroupTitle }}
            </div>
          </template>
          <li v-for="group in filterdGroups" :key="group.gid" class="list-item" @click="selectGroup(group)">
            <div class="list-left">
              <img class="avatar" width="30" height="30" :alt="group.nickname" :src="group.avatar">
            </div>
            <div class="list-right">
              <div class="top">
                <span class="nickname">{{ group.nickname }}</span>
              </div>
              <div class="bottom">
                <span class="content">{{ group.description }}</span>
              </div>
            </div>
          </li>
        </el-collapse-item>
        <el-collapse-item name="4">
          <template slot="title">
            <div style="margin-left: 20px;">
              {{ collapseContactTitle }}
            </div>
          </template>
          <li v-for="contact in filterdContacts" :key="contact.uid" class="list-item"
            @click="selectContact(contact)">
            <div class="list-left">
              <img class="avatar" width="30" height="30" :alt="contact.nickname" :src="contact.avatar">
            </div>
            <div class="list-right">
              <div class="top">
                <span class="nickname">{{ contact.realName }}</span>
              </div>
              <div class="bottom">
                <span class="content">{{ contact.description }}</span>
              </div>
            </div>
          </li>
          <el-skeleton v-if="isLoading" animated />
          <el-empty v-if="filterdContacts.length === 0 && !isLoading" description="空"></el-empty>
        </el-collapse-item>
      </el-collapse>
    </div>
    <el-dialog v-dialogDrag :title="createGroupTip" :visible.sync="createGroupDialogVisible" width="650px" center>
      <el-transfer filterable :filter-placeholder="inputNameTip" v-model="selectedContacts" :data="contactData"
        :titles="[contactsTip, groupMembersTip]">
      </el-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="createGroupDialogVisible = false">{{ $t('cancel') }}</el-button>
        <el-button size="mini" type="primary" @click="doCreateGroup">{{ $t('ok') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
// import bus from "@/util/eventbus"
const constants = require('@/util/constants')

export default {
  name: 'bd-contact-aside',
  data () {
    return {
      search: '',
      activeNames: ['4'],
      createGroupDialogVisible: false,
      selectedContacts: [],
      isLoading: true,
      loadingWidget: ""
    }
  },
  computed: {
    ...mapGetters([ 'userInfo', 'userContacts', 'userGroups', 'userCurrentContact', 'showAuthority' ]),
    createGroupTip () {
      return this.$t('createGroup')
    },
    inputNameTip () {
      return this.$t('inputName')
    },
    groupMembersTip () {
      return this.$t('groupMembers')
    },
    contactsTip () {
      return this.$t('contacts')
    },
    filterdContacts () {
      return this.userContacts.filter(contact => {
        return contact.realName.includes(this.search) // && !contact.robot && contact.username != 'bytedesk_notification'
      })
    },
    contactData () {
      const data = []
      this.userContacts.forEach((contact, index) => {
        data.push({
          label: contact.realName,
          key: contact.uid
        })
      })
      return data
    },
    filterdGroups () {
      return this.userGroups.filter(group => {
        return group.nickname.includes(this.search)
      })
    },
    searchTip () {
      return this.$t('search')
    },
    collapseGroupTitle () {
      return this.$t('groupChat') + ' (' + this.userGroups.length + ')'
    },
    collapseContactTitle () {
      return this.$t('contacts') + ' (' + this.filterdContacts.length + ')'
    }
  },
  methods: {
    ...mapActions([ 'createGroup', 'updateChatType', 'getContacts', 'getGroups' ]),
    handleSuccess(response) {
      this.isLoading = false
      // 同事加载完毕
      // if (this.loadingWidget) {
      //   this.loadingWidget.close()
      // }
    },
    handleFailed(error) {
      this.isLoading = false
      // 同事加载完毕
      // if (this.loadingWidget) {
      //   this.loadingWidget.close()
      // }
    },
    refreshData () {
      console.log('refreshData')
      let payload = { successcb: this.handleSuccess, failedcb: this.handleError }
      this.getContacts(payload)
      //
      this.getGroups()
      // https://element.eleme.cn/#/zh-CN/component/loading
      // TODO: 加载时间过长，暂时注释掉
      // this.loadingWidget = this.$loading({
      //   // target: 'bd-message',
      //   lock: false,
      //   fullscreen: false,
      //   text: "Loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });
    },
    showCreateGroupDialog () {
      this.createGroupDialogVisible = true
    },
    // 创建群组, 昵称组成：最多三个被选择人的realName
    doCreateGroup () {
      this.createGroupDialogVisible = false
      if (this.selectedContacts.length === 0) {
        return
      }
      let n = 0
      let nickname = this.userInfo.realName
      for (let i = 0; i < this.selectedContacts.length; i++) {
        const uid = this.selectedContacts[i]
        for (let j = 0; j < this.userContacts.length; j++) {
          const contact = this.userContacts[j]
          if (uid === contact.uid) {
            nickname = nickname + ',' + contact.realName
            n++
            if (n > 2) {
              break
            }
          }
        }
      }
      let payload = { nickname: nickname, selectedContacts: this.selectedContacts }
      this.createGroup(payload)
      this.selectedContacts = []
    },
    handleChange (val) {
      console.log(val)
    },
    selectGroup (group) {
      let payload = { type: constants.THREAD_TYPE_GROUP, object: group }
      this.updateChatType(payload)
    },
    selectContact (contact) {
      let payload = { type: constants.THREAD_TYPE_CONTACT, object: contact }
      this.updateChatType(payload)
    }
  },
  created () {
    // console.log('contact aside created')
    this.refreshData()
  },
  mounted () {
    // let app = this
    // bus.$on(constants.EVENT_BUS_CONTACT_LOAD_FINISHED, () => {
    //   app.isLoading = false
    //   // 同事加载完毕
    //   if (app.loadingWidget) {
    //     app.loadingWidget.close()
    //   }
    // })
  }
}
</script>

<style scoped>
#bd-contact-aside {
  width: 100%;
  height: 100%;
  float: left;
}
.contact-search {
  padding: 12px 12px 12px 12px;
}
.list-item {
  padding: 5px 5px 5px 5px;
  margin-bottom: 0px;
  border-bottom: 1px solid beige;
  height: 50px;
}
.list-item:hover {
  background-color: rgb(220,220,220)
}
.active {
  background-color:darkkhaki
}
.list-item .avatar {
  border-radius: 2px;
  margin-right: 2px;
}
li {
  list-style: none;
}
.list-left {
  margin-top: 4px;
  margin-left: 2px;
  width: 25px;
  height: 25px;
  float: left;
}
.list-right {
  margin-left: 42px;
}
.list-right .top {
  margin-top: 2px;
  text-align: left;
}
span.nickname {
  display: inline-block;
  vertical-align: top;
  font-size: 14px;
  width: calc(100% - 120px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
span.timestamp {
  float: right;
  color:gray;
  font-size: 12px;
  vertical-align: top;
  width: 68px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list-right .bottom {
  width: 0%;
  text-align: left;
}
.list-right .bottom-queue {
  width: 90%;
  text-align: left;
}
.list-right .bottom .content{
  font-size: 12px;
  width: 150px;
  height: 100%;
  color: gray;
  overflow: hidden;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list-right .unreadCount {
    margin-top: 4px;
    float: right;
    font-size: 10px;
    width: 12px;
    height: 12px;
    line-height: 12px;
    text-align: center;
    border-radius:5px;
    color: white;
    background-color: red;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
